const siteHeader = document.querySelector('.site-header');

if (siteHeader) {
  // Add class to body after some scroll
  const addScrollingClass = () => {
    const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
    const calcOffset = windowWidth() > breakpointMd ? 30 : 60;
    document.body.classList.toggle('is-scrolled', topOffset > calcOffset);
  };

  let lastScrollTop = 0;
  let ticking = false;

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        addScrollingClass();

        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        document.body.classList.toggle('is-scrolled-up', currentScrollTop < lastScrollTop);

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
        ticking = false;
      });
      ticking = true;
    }
  };

  addScrollingClass();
  window.addEventListener('scroll', onScroll);

  // Toggle modal
  initModal('menu');
  initModal('wcag');
  initModal('search');

  const defaultSearchInput = document.querySelector('.header-search--default .header-search__input-field');
  attachEvent('.site-header__search-trigger', 'click', () => {
    setTimeout(() => {
      defaultSearchInput?.focus();
    }, 50);
  });
}

// **************************************************

const updateHeaderHeight = () => {
  const height = siteHeader ? siteHeader.offsetHeight : 0;
  document.documentElement.style.setProperty('--header-height', `${height}px`);
};

updateHeaderHeight();
window.addEventListener('resize', updateHeaderHeight);

attachEvent('.notification-bar__close', 'click', (ev) => {
  ev.target.closest('.notification-bar')?.remove();
  updateHeaderHeight();
  ev.preventDefault();
});
